<template>
	<div class="mainWrapper direct-purchase">
		<h1>Import Direct Purchase</h1>
		<div class="form" v-if="brands.length > 0">
			<div>
				<span class="label">BRAND</span>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
					:disabled="selectedBrand"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div v-if="selectedBrand">
				<span class="label">UPLOAD FILE</span>
				<b-field class="file">
					<input type="file" @change="loadTextFromFile" />
				</b-field>
			</div>

			<div v-if="product">
				<span class="label">ADD</span>
				<b-button type="is-info" icon-left="plus-circle-outline" @click="submit">ADD PRODUCT</b-button>
			</div>
		</div>

		<div class="transfer-date">
			<span class="label">RECEIVED DATE</span>
			<b-datepicker :date-formatter="dateFormatter" v-model="received_date" icon="calendar-today"> </b-datepicker>
		</div>

		<div class="list">
			<!-- v-if="products.length > 0" -->
			<div class="products-list header">
				<div>
					BD CODE
				</div>

				<div>
					BARCODE
				</div>

				<div>
					NAME
				</div>

				<div>
					QUANTITY
				</div>

				<div>
					REMARK
				</div>
			</div>

			<div v-for="(item, index) of products" v-bind:key="index" class="products-list">
				<div>
					{{ item.bd_code }}
				</div>

				<div>
					{{ item.barcode }}
				</div>

				<div>
					{{ item.name }}
				</div>

				<div>
					<input name="qtyInput" class="qtyInput" type="number" v-model="item.qty" disabled />
				</div>

				<div>
					<textarea name="remark" class="remark" placeholder="Remark" v-model="item.remark" disabled />
				</div>
			</div>
		</div>

		<div v-if="products.length > 0" class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="save()">SAVE</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddDirectPurchase',
	data: function() {
		return {
			brands: [], // List of brands from API
			selectedBrand: null, // Selected brand
			bdcodeData: [], // API bdcode data
			searchData: [], // API Search data
			brandSuggestions: '', // List of brands
			product: null, // 1 selected product
			products: [], // Selected products
			name: null,
			supplier: null,
			received_date: null,
			content: null
		}
	},
	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		content: function() {
			this.verifyContent()
		},

		selectedBrand: function(newData) {
			this.product = null
			this.products = []
		}
	},

	mounted: async function() {
		// Get list of brands
		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	methods: {
		verifyContent: async function() {
			for (var transfer of this.content) {
				const bdCode = transfer.bdCode
				const qty = transfer.qty
				const remark = transfer.remark

				const data = {
					brand: this.selectedBrand._id,
					bd_code: bdCode
				}

				const apiProductDetail = await this.$api.searchProduct({ data })

				console.log(apiProductDetail)

				if (!apiProductDetail || apiProductDetail.data.count == 0) {
					this.$swal.fire('Error!', bdCode + ' is not in ' + this.selectedBrand.name + ' brand!', 'error')
					this.error = true
					return
				}

				let apiProduct = apiProductDetail.data.list[0]

				const duplicate = this.products.filter(product => {
					return product._id == apiProduct._id
				})

				if (duplicate.length > 0) {
					this.$swal.fire('Duplicate!', bdCode + ' is already added!', 'error')
					this.error = true
					return
				}

				apiProduct.qty = qty
				apiProduct.remark = remark

				this.products.push(apiProduct)
			}
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			this.error = false
			const file = ev.target.files[0]
			const reader = new FileReader()

			let error = false
			let productData = []

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				// Remove first row
				raw.shift()

				// Loop every row to put it in array
				raw.map(data => {
					var splitData = data.split(/,/)

					var newData = {}

					newData.bdCode = splitData[0]
					newData.qty = splitData[1]
					newData.remark = splitData[2]

					if ((newData.bdCode && !newData.qty) || newData.qty == '') {
						this.$swal.fire('Error!', newData.bdCode + ' quantity cannot be blank', 'error')
						error = true
						return
					}

					if ((newData.bdCode && !newData.remark) || newData.remark == '') {
						this.$swal.fire('Error!', newData.bdCode + ' remark cannot be blank', 'error')
						error = true
						return
					}

					if (newData.bdCode) {
						productData.push(newData)
					}
				})
			}

			if (error == false) {
				this.content = productData
			}

			reader.readAsText(file)
		},

		save: async function() {
			var newData = []

			this.products.map(product => {
				var productData = {}

				productData.product = product._id
				productData.received_date = this.$moment(this.received_date).format('DD/MM/YYYY')
				productData.supplier = this.supplier
				// productData.price = product.price;
				productData.currency = 'MMK'
				productData.qty = product.qty
				productData.remark = product.remark

				newData.push(productData)
			})

			const data = {
				direct_purchase_items: newData
			}

			const apiSaveDP = await this.$api.saveDP({ data })

			if (apiSaveDP !== undefined) {
				this.$swal.fire(apiSaveDP.data.direct_purchase.code)

				this.$router.push('/direct-purchase')
			}
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		submit: async function() {
			this.product.received_date = null
			this.product.qty = null
			this.product.remark = null

			this.products.push(this.product)

			this.product = null
			this.searchData = []
		},

		update: function(index, item, value) {
			console.log(index, item, value)

			if (item == 'qty') {
				this.products[index].qty = Number(value)
			}

			// if (item == "price") {
			// 	this.products[index].price = Number(value);
			// }
		},

		// Autocomplete search
		searchProducts: async function(name) {
			if (name.length > 1) {
				const data = {
					brand: this.selectedBrand._id,
					bd_code: name
				}

				const apiSearchProduct = await this.$api.searchProduct({ data })

				this.searchData = apiSearchProduct.data.list
			}
		}
	}
}
</script>

<style scoped>
.transfer-date {
	width: 300px;
	margin-bottom: 2em;
}

.form {
	width: 500px;
	text-align: left;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 20px;
	width: 100%;
	margin-bottom: 40px;
}

span.label {
	font-size: 12px;
	font-weight: bold;
	color: #ccc;
	text-align: left;
	margin-bottom: 10px;
}

/* .products-list {
	margin-bottom: 20px;
	display: grid;

	grid-gap: 20px;
	width: 100%;
	text-align: left;
	font-weight: bold;
} */

.products-list {
	margin: auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	padding: 20px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.header {
	color: #aaa;
	font-weight: bold;
	font-size: 14px;
	margin-bottom: 10px;
}

.qtyInput {
	width: 90px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
	/* background: #70a15a; */
}

.priceInput {
	width: 150px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
}

.remark {
	width: 100%;
	height: 50px;
	border-radius: 4px;
	border: 1px solid #ccc;
	background-color: #fff;
	padding: 5px;
	color: #000;
	font-size: 14px;
	overflow-wrap: break-word;
}
</style>
